const API_URL = process.env.REACT_APP_API_URL;
const AREA_BILLING = API_URL + "/billing/";

const BILLING_FILE = "BillingFile/";
const BILLING_REVIEW = "BillingReview/";

export const BillingApiUrl = {
    BILLING_GENERATE_MANUAL: AREA_BILLING + BILLING_FILE + "GenerateManual",
    BILLING_GET_GENERATE_MANUAL_ACTION: AREA_BILLING + BILLING_FILE + "GetGenerateManualAction",
    BILLING_FILE_DOWNLOAD: AREA_BILLING + BILLING_FILE + "DownloadFile",
    BILLING_REVIEW_VIEW: AREA_BILLING + BILLING_REVIEW + "ViewBilling",
    BILLING_REVIEW_APPROVE: AREA_BILLING + BILLING_REVIEW + "ApproveBilling",
}
